import { css } from "@emotion/react";
import { TOAST_CLOSE_ANIMATION_NAME } from "./constants";
import { kitText } from "../../styles";

export const styles = {
  toastPositioning: css`
    display: grid;
    grid-template-rows: 1fr;
    align-items: end;
    animation: toast-slide 300ms cubic-bezier(0.54, 1.12, 0.38, 1.11);

    &.closing {
      animation: ${TOAST_CLOSE_ANIMATION_NAME} 300ms
        cubic-bezier(0.4, 1, 0.75, 0.9) forwards;
    }

    &.closed {
      display: none;
    }

    @keyframes toast-slide {
      from {
        opacity: 0;
        margin-bottom: -50px;
      }
      to {
        opacity: 1;
        margin-bottom: 0;
      }
    }

    @keyframes ${TOAST_CLOSE_ANIMATION_NAME} {
      from {
        grid-template-rows: 1fr;
        opacity: 1;
        filter: blur(0);
      }
      to {
        grid-template-rows: 0fr;
        opacity: 0;
        filter: blur(10px);
      }
    }
  `,
  toastGridWrapper: css`
    min-height: 0;
    grid-row: span 2;
  `,
  toast: css`
    --kit-toast-spacing: var(--spacing-16);
    margin-top: var(--kit-toaster-spacing, var(--kit-toast-spacing));
    display: flex;
    gap: var(--kit-toast-spacing);
    padding: var(--kit-toast-spacing);
    border-radius: var(--border-radii-base);
    border-left: 4px solid var(--kit-toast-color);
    background-color: var(--kit-toast-background-color);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);

    .kit-Toast:first-of-type & {
      margin-top: 0;
    }
  `,
  toastContent: css`
    ${kitText.variant.body}
    flex: 1;
  `,
  toasterPositioning: css`
    --kit-toaster-spacing: var(--spacing-24);
    position: fixed;
    inset: 0 0 0 auto;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: var(--kit-toaster-width);
    pointer-events: none;
    padding: var(--kit-toaster-spacing);
    overflow: hidden;

    > * {
      pointer-events: auto;
    }
  `
};
